module.exports = __webpack_public_path__ + "media/white-label/typography-t-9866764f.png";